<template>
  <layout-auth style="background: #f3f5f7 !important">
    <main class="container-wrap">
      <div class="rectangle">
        <v-row>
          <v-col style="padding-top: 6%">
            <h1 class="source-sans-pro-ligh-2 pb-10">
              {{ $t("nav.selectOption") }}
            </h1>
          </v-col>
        </v-row>
        <div class="row center">
          <v-col
            cols="12"
            sm="4"
            md="2"
            style="cursor: pointer; max-width: 240px"
            v-for="link in links"
            :key="link.to"
          >
            <router-link :to="link.to">
              <div
                class="rectangle-copy-3"
                style="border: 2px solid #fff; transition: border .5s;"
                :ref="link.icon"
                @mouseenter="addBorder(link.icon)"
                @mouseleave="removeBorder(link.icon)"
              >
                <div class="centrado-img">
                  <div :style="`background-color: ${entityConfig.primaryColor};`" class="circle-icon">
                    <div
                      :style="`mask: url(${link.srcImg}) no-repeat center / contain; -webkit-mask: url(${link.srcImg}) no-repeat center / contain; background-color: ${entityConfig.secondaryColor};`"
                      class="icon-img"
                    ></div>
                  </div>
                </div>
                <div>
                  <small
                    :style="`color: ${entityConfig.primaryColor}`"
                    class="link-text centrado-img"
                    >{{ link.text }}
                  </small>
                </div>
              </div>
            </router-link>
          </v-col>
        </div>
        <overlay :visible="spinner" :opacity="1"></overlay>

        <div class="row pad center"></div>
      </div>
    </main>
  </layout-auth>
</template>

<style scoped lang="scss">
@import "./index.style";
</style>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Overlay from "../../components/layouts/overlay.vue";

export default {
  name: "App",
  components: {
    "layout-auth": LayoutAuth,
    Overlay,
  },
  data() {
    return {
      spinner: true,
      entityConfig: {},
      links: [
        {
          to: "/facturas",
          icon: "mdi-file-document-outline",
          srcImg: "assets/images/icons/doc.svg",
          text: this.$t("nav.invoices"),
        },
        {
          to: "/anticipo-facturas",
          icon: "mdi-file-move-outline",
          srcImg: "assets/images/icons/transfer-money.svg",
          text: this.$t("nav.invoiceAdvance"),
        },
        {
          to: "/anticipo-automatico",
          icon: "mdi-swap-horizontal",
          srcImg: "assets/images/icons/transfer.svg",
          text: this.$t("nav.autoAdvance"),
        },
        {
          to: "/cuentas-de-abono",
          icon: "mdi-bank-check",
          srcImg: "assets/images/icons/recive-money.svg",
          text: this.$t("nav.bankAccounts"),
        },
        {
          to: "/gestion-de-proveedores",
          icon: "mdi-account-multiple-check-outline",
          srcImg: "assets/images/icons/profile.svg",
          text: this.$t("nav.personalDataManagement"),
        },
      ],
    };
  },

  mounted() {
    setTimeout(() => {
      this.entityConfig = this.$store.state.entityConfig.config;
      this.spinner = false;
    }, 1000);
  },
  methods: {
    addBorder(refId) {
      this.$refs[refId][0].style.border = `2px solid ${this.entityConfig.primaryColor}`;
    },
    removeBorder(refId) {
      this.$refs[refId][0].style.border = `2px solid #ffffff`;
    },
  },
};
</script>

